import UserEditor, { DEFAULT_USER_DATA } from 'components/UserEditor/UserEditor';
import UserEditSubmitButton from 'components/UserEditSubmitButton/UserEditSubmitButton';
import { PermsContext } from 'contexts/PermsContext';
import { useContext, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa';
import { createFusionUser } from 'services/user/user.service';

export default function CreateUser() {
  const [formData, setFormData] = useState(DEFAULT_USER_DATA);
  const [copied, setCopied] = useState(true);
  const [activateUrl, _setActivateUrl] = useState('');
  const setActivateUrl = (newValue) => {
    setCopied(false);
    _setActivateUrl(newValue);
  };
  const [errorMsg, setErrorMsg] = useState('');
  const [canAssignSM, setCanAssignSM] = useState(false);
  const perms = useContext(PermsContext);

  const onSubmit = () => {
    if (!submitButtonEnabled()) return;

    setErrorMsg('');

    // Make api calls
    createFusionUser(
      formData.roles,
      formData.base,
      formData.department,
      formData.rank,
      formData.name,
      formData.email,
      formData.employeeId,
      formData.phone,
      formData.gender,
      formData.birthday,
      JSON.stringify({
        street: formData.address,
        city: formData.city,
        state: formData.state,
        zipcode: formData.zipcode,
      }),
      JSON.stringify({
        name: formData.eContactName,
        phone: formData.eContactPhone,
      }),
      formData.isAdmin || false,
      formData.maintenance !== 0,
      formData.maintenance,
      Number(formData.serviceManager) || 0,
    )
      .then((res) => {
        if (res.status === 201) setActivateUrl(res.data.Link);
        else if (res.response.status === 400) setErrorMsg(res.response.data.message); //alert(res.response.data.message);
      })
      .catch((err) => {
        console.error('Error in createFusionUser:', err);
      });
  };

  //Set permission to assign service manager role, only on mount
  useEffect(() => {
    const accessLevel = perms?.accessLevel;
    const serviceManagerFlag = perms?.serviceManagerFlag;
    setCanAssignSM(
      accessLevel === 13 ||
        accessLevel === 8 ||
        ((accessLevel === 11 || accessLevel === 12) && serviceManagerFlag),
    );
  }, [perms?.accessLevel, perms?.serviceManagerFlag]);

  //reset the form data on discard
  const onDiscard = () => setFormData(DEFAULT_USER_DATA);

  const submitButtonEnabled = () => {
    //check required values
    return (
      formData.name &&
      formData.email &&
      formData.roles &&
      formData.base &&
      formData.department &&
      formData.rank
    );
  };

  return (
    <div
      className="user-select-none w-100 h-100 d-flex flex-column"
      onClick={() => {
        if (activateUrl) setActivateUrl('');
      }}
    >
      <UserEditor value={formData} onChange={setFormData} />
      <div className="d-flex flex-column flex-lg-row align-items-lg-baseline justify-content-lg-end mt-lg-2 gap-2">
        {errorMsg && <p data-error="true">{errorMsg}</p>}
        <div className="d-flex flex-column flex-lg-row-reverse align-items-lg-center gap-2 justify-content-center align-content-center">
          <UserEditSubmitButton
            onSubmit={onSubmit}
            onAdmin={(value) => setFormData({ ...formData, isAdmin: value })}
            isAdmin={formData.isAdmin || false}
            disabled={!submitButtonEnabled()}
          />
          {/* Service Manager Checkbox */}
          {canAssignSM && (
            <>
              <Form.Check
                type="checkbox"
                checked={Boolean(formData.serviceManager)}
                onChange={(e) =>
                  setFormData({ ...formData, serviceManager: e.target.checked ? 1 : 0 })
                }
                disabled={false}
              />
              <div>User is a Service Manager </div>
            </>
          )}

          {/* Discard Button */}
          <Button variant="dark" className="p-3 h-100 border border-secondary" onClick={onDiscard}>
            Discard
          </Button>
        </div>
      </div>

      {/* Popup with link copy */}
      {activateUrl && (
        <div
          className="position-absolute top-50 start-50 z-2 bg-primary-shadow text-white d-flex flex-column gap-2 rounded-3 p-2 border border-1 border-black text-center translate-middle w-100 w-sm-md"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="mb-0 fs-6">This link will be sent to the email provided for this user.</p>
          <p className="mb-0 fs-6">
            Here is a copy for you in case that email fails to be received.
          </p>
          <div className="bg-background text-white user-select-text d-flex rounded-5 align-items-center justify-content-between border border-1 border-black">
            {activateUrl}
            <Button
              className="btn-transparent"
              onClick={() => {
                navigator.clipboard.writeText(activateUrl);
                setCopied(true);
              }}
            >
              <FaCopy />
            </Button>
          </div>
          {copied && <p className="text-success">URL copied to clipboard!</p>}
        </div>
      )}
    </div>
  );
}
